module.exports = __webpack_public_path__ + "static/gtm_3-ed48b38671e9e302a06058891dc62b62.png";